import { UserPlus, FolderPlus, CheckSquare, ArrowUpCircle, ArrowDownCircle, Upload } from "lucide-react";
import tr from "@/i18n/tr";
import { toast } from "sonner";

const ITEMS = [
    { key: "new-client",  Icon: UserPlus,        label: tr.dashboard.quickActions.newClient,   desc: tr.dashboard.quickActions.newClientDesc,   accent: "bg-[hsl(var(--brand))]/10 text-[hsl(var(--brand))]" },
    { key: "new-project", Icon: FolderPlus,      label: tr.dashboard.quickActions.newProject,  desc: tr.dashboard.quickActions.newProjectDesc,  accent: "bg-[hsl(var(--info))]/10 text-[hsl(var(--info))]" },
    { key: "new-task",    Icon: CheckSquare,     label: tr.dashboard.quickActions.newTask,     desc: tr.dashboard.quickActions.newTaskDesc,     accent: "bg-[hsl(var(--success))]/10 text-[hsl(var(--success))]" },
    { key: "new-income",  Icon: ArrowUpCircle,   label: tr.dashboard.quickActions.newIncome,   desc: tr.dashboard.quickActions.newIncomeDesc,   accent: "bg-[hsl(var(--brand))]/10 text-[hsl(var(--brand))]" },
    { key: "new-expense", Icon: ArrowDownCircle, label: tr.dashboard.quickActions.newExpense,  desc: tr.dashboard.quickActions.newExpenseDesc,  accent: "bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]" },
    { key: "upload",      Icon: Upload,          label: tr.dashboard.quickActions.uploadFile,  desc: tr.dashboard.quickActions.uploadFileDesc,  accent: "bg-[hsl(var(--muted-foreground))]/10 text-muted-foreground" },
];

export default function QuickActions() {
    const onClick = (label) => {
        toast("Yakında", {
            description: `${label} sonraki geliştirme aşamasında oluşturulacaktır.`,
        });
    };

    return (
        <div className="card-elevated p-5">
            <div className="flex items-start justify-between mb-4">
                <div>
                    <div className="text-[13px] font-semibold text-foreground">{tr.dashboard.quickActions.title}</div>
                    <div className="text-[11.5px] text-muted-foreground mt-0.5">Sık kullanılan işlemler</div>
                </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
                {ITEMS.map(({ key, Icon, label, desc, accent }) => (
                    <button
                        key={key}
                        type="button"
                        onClick={() => onClick(label)}
                        data-testid={`quick-action-${key}`}
                        className="group flex items-center gap-3 rounded-2xl border border-border bg-background p-3 text-left transition-all hover:shadow-card-hover hover:border-[hsl(var(--brand))]/40"
                    >
                        <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${accent}`}>
                            <Icon className="h-5 w-5" />
                        </div>
                        <div className="min-w-0">
                            <div className="text-[12.5px] font-semibold text-foreground truncate">{label}</div>
                            <div className="text-[10.5px] text-muted-foreground truncate">{desc}</div>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
}
